export default __webpack_public_path__ + "static/media/overlay_bg_form.38c3e437.png";